import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import CannedMessages from "./components/CannedMessages";

export default () => (
  // <Route exact path="/settings/CarrierRate/:_id" component={CarrierRate} />
  <PrivateRoute
    key="/settings/canned-messages"
    exact={true}
    path="/settings/canned-messages"
    component={CannedMessages}
  />
);



// WEBPACK FOOTER //
// src/modules/screens/settings/CannedMessages/routes.js